import React, { useState } from "react";
import styled from "styled-components";
import {
  CButton
} from "@carrefour/design-system-components-react";
import { AlertStatus } from "../../utils/alertUtils";
import "reactjs-popup/dist/index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AlertActionPlan from "../AlertActionPlan/AlertActionPlan";

type AlertCardActionProps = {
  status: AlertStatus;
  alertSeriesId: string;
  dashboardUrl?: string;
  deadlineDate?: string;
  actionPlanSubmitted: () => void;
};

const AlertCardButton = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 10px 16px 16px 16px;
`;

const AlertCardAction: React.FC<AlertCardActionProps> = ({
  status,
  alertSeriesId,
  dashboardUrl,
  deadlineDate,
  actionPlanSubmitted
}) => {
const [open, setOpen] = useState(false);

return (
  <AlertCardButton>
    {status === AlertStatus.RESOLVED ? (
      <CButton
        onClick={() => setOpen(true)}
        type="button"
        size="s"
        variation="tertiary"
        fullWidth
        tone="main"
      >
        Plan d'action
      </CButton>
    ) : (
      <>
        <CButton
          type="button"
          size="s"
          appendIcon="external-link"
          variation="tertiary"
          tone="main"
          href={dashboardUrl}
          target="_blank"
          fullWidth
        >
          Dashboard
        </CButton>
        <CButton
          onClick={() => setOpen(true)}
          type="button"
          size="s"
          fullWidth
        >
          {status === AlertStatus.TOADJUST
            ? "Ajuster le plan"
            : status === AlertStatus.NEW || status === AlertStatus.IGNORED
              ? "Créer un plan"
              : "Plan d'action"}
        </CButton>
      </>
    )}
    <AlertActionPlan
      alertSeriesId={alertSeriesId}
      show={open}
      status={status}
      deadlineDate={deadlineDate}
      onClose={() => setOpen(false)}
      actionPlanSubmitted={actionPlanSubmitted}
    />
    <ToastContainer />
  </AlertCardButton>
);
};

export default AlertCardAction;